import { render, staticRenderFns } from "./ResetPass.vue?vue&type=template&id=4ae27d36"
import script from "./ResetPass.vue?vue&type=script&lang=js"
export * from "./ResetPass.vue?vue&type=script&lang=js"
import style0 from "./ResetPass.vue?vue&type=style&index=0&id=4ae27d36&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae27d36')) {
      api.createRecord('4ae27d36', component.options)
    } else {
      api.reload('4ae27d36', component.options)
    }
    module.hot.accept("./ResetPass.vue?vue&type=template&id=4ae27d36", function () {
      api.rerender('4ae27d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ResetPass.vue"
export default component.exports